import { render } from "./AuthenticatorPage.vue?vue&type=template&id=cb55e1d0"
import script from "./AuthenticatorPage.vue?vue&type=script&lang=js"
export * from "./AuthenticatorPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__